import { MdAdminPanelSettings, MdLogout } from "react-icons/md";
import { Navigate, Outlet } from "react-router-dom";
import { limparSessaoAdminPlataforma } from "../services/apiAdminPlataforma";

// Layout separado do LayoutPrivado (tenant) — a sessão de admin de
// plataforma não tem fazenda/contrato, então não pode reutilizar o mesmo
// AuthContext nem a mesma barra lateral.
const LayoutAdminPlataforma = () => {
  const token = localStorage.getItem("admin_plataforma_token");
  const userRaw = localStorage.getItem("admin_plataforma_user");

  if (!token) {
    return <Navigate to="/admin-plataforma/login" replace />;
  }

  const user = userRaw ? JSON.parse(userRaw) : null;

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-gray-900 text-white px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <MdAdminPanelSettings size={22} className="text-amber-500" />
          <span className="font-semibold">Administração da Plataforma</span>
        </div>
        <div className="flex items-center gap-4 text-sm">
          {user && <span className="text-gray-300">{user.nome_completo}</span>}
          <button
            onClick={limparSessaoAdminPlataforma}
            className="flex items-center gap-1 text-gray-300 hover:text-white transition-colors"
            title="Sair"
          >
            <MdLogout size={18} />
            Sair
          </button>
        </div>
      </header>

      <main className="p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutAdminPlataforma;
